export default {"src":"/_next/static/media/logo-qive.16d44859.svg","height":32,"width":90};